import {
  FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_REQUEST,
  FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_SUCCESS,
  FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_FALUIRE,
} from './listAllProjectTemplateTaskGroupByProjectIDTypes'

const initialState = {
  loading: false,
  projectTemplateTaskGroupList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_SUCCESS : return {
      ...state,
      projectTemplateTaskGroupList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      projectTemplateTaskGroupList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
